"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BeatLoader_1 = __importDefault(require("react-spinners/BeatLoader"));
var Loader = function (_a) {
    var color = _a.color, _b = _a.background, background = _b === void 0 ? 'transparent' : _b;
    return (react_1.default.createElement("div", { className: "flex-auto flex items-center justify-center text-mantis " + (background === 'white' ? 'bg-white' : '') },
        react_1.default.createElement(BeatLoader_1.default, { color: color !== null && color !== void 0 ? color : '#0078B3' })));
};
exports.default = Loader;
//# sourceMappingURL=loader.js.map